import { ThemeIcon } from "@mantine/core"
import { IconSquare, IconSquareCheck } from "@tabler/icons-react"

interface Props {
  checked: boolean
}

export function IconCheckBox(props: Props) {
  return (
    <ThemeIcon
      c={"var(--mantine-color-text)"}
      variant="transparent"
      size={"sm"}
    >
      {props.checked ? <IconSquareCheck /> : <IconSquare />}
    </ThemeIcon>
  )
}
